import { Badge, Box, Button, Fade, Modal } from "@mui/material";
import { useState } from "react";
import { DoneAll } from "@mui/icons-material";
import NewNotifications from "./NewNotifications";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { notificationSelector } from "../redux/slices/notificationSlice";
import { getNotifications, updateAllNotifications, updateNotifications } from "../api/notification";
import { isClientPreview } from "../utils/clientPreview";
import NotificationsPanel from "./NotificationsPanel";

const style = {
  position: "absolute",
  top: "10%",
  right: "7%",
  width: "25%",
  height: "550px",
  overflowY: "scroll",
  textAlign: "center",
  bgcolor: "#fff",
  border: "none",
  boxShadow: "none",
  outline: "none",
  //   padding: "20px",
  borderRadius: "10px",
};

export default function NotificationModal({loggedUser, icon }) {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { notificationInfo } = useSelector(notificationSelector);

  const notificationIds = notificationInfo?.notification
    ?.filter((item) => item.is_read === false)
    .map((notification) => {
      return { _id: notification._id };
    });
  const dispatch = useDispatch();
  const totalNotifications = notificationInfo?.total_unread_notifications;

  const today = notificationInfo?.notification?.filter(
    (item) => item.arrived_in === "today"
  );

  const yesterdayNotifications = notificationInfo?.notification?.filter(
    (item) => item.arrived_in === "yesterday"
  );

  const productsLocation =loggedUser?.user?.role !=="admin"

  return (
    <>
      <div style={{ margin: "0 20px", cursor:"pointer" }}>
        <Badge
          badgeContent={totalNotifications}
          color="error"
          size="small"
          sx={{
            "& .MuiBadge-badge": {
              padding: 0,
              fontSize: "10px",
              fontWeight: 700,
            },
          }}
          onClick={(e) => {
            setAnchorEl(e.currentTarget);
            handleOpen();
            // Only send a read update when something is unread; an empty body made the server fail.
            if (notificationIds?.length) dispatch(updateNotifications(notificationIds));
          }}
        >
          {icon || (
            <Icon
              icon="eva:bell-fill"
              width="20"
              height="20"
              style={{ color: productsLocation ? "#fff" :"rgb(99, 115, 129)" }}
            />
          )}
        </Badge>
      </div>

      {isClientPreview() ? (
        <NotificationsPanel
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          notifications={notificationInfo?.notification || []}
          unread={totalNotifications || 0}
          onReadAll={() => dispatch(updateAllNotifications())}
          onRefresh={() => dispatch(getNotifications({ page: 0, size: 50 }))}
        />
      ) : (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} className="">
            <div
              className="flexbox"
              style={{
                textAlign: "left",
                padding: "20px",
                borderBottom: "0.5px dashed lightgray",
              }}
            >
              <div style={{}}>
                <h5
                  style={{
                    fontWeight: 600,
                    lineHeight: "1.5",
                    fontSize: "1rem",
                  }}
                >
                  Notifications
                </h5>
                <h6
                  style={{
                    marginTop: 10,
                    marginBottom: 0,
                    color: "rgb(99, 115, 129)",
                  }}
                >
                  You have {totalNotifications} unread messages
                </h6>
              </div>
              <DoneAll style={{ color: "#36ba59", cursor:"pointer" }} onClick={() => dispatch(updateAllNotifications())}/>
            </div>
            <div
              style={{
                textAlign: "left",
                height: "400px",
                overflowY: "scroll",
              }}
              className="hide_scrollbar"
            >
              {/* <Divider /> */}
              <NewNotifications
                notifications={today || []}
                yesterdayNotifications={yesterdayNotifications}
              />
            </div>
            {/* <Divider sx={{ border: "0.5px dashed lightgray" }} /> */}
            <div
              style={{
                textAlign: "center",
                margin: "10px 0px",
                padding: "10px 20px 0px 20px",
                borderTop: "0.5px dashed lightgray",
              }}
            >
              <Link to="/customer/notifications">
                <Button variant="title_purple" onClick={handleClose}>
                  View all
                </Button>
              </Link>
            </div>
          </Box>
        </Fade>
      </Modal>
      )}
    </>
  );
}
